"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gatsbyPluginTransitionLink = _interopRequireDefault(require("gatsby-plugin-transition-link"));

var _gsap = require("gsap");

var _colorConvert = _interopRequireDefault(require("color-convert"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PaintDrip =
/*#__PURE__*/
function (_Component) {
  _inherits(PaintDrip, _Component);

  function PaintDrip(props) {
    var _this;

    _classCallCheck(this, PaintDrip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PaintDrip).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "createRipple", function (_ref, event, hex, color) {
      var length = _ref.length;
      var body = document.body;
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      var piTwo = Math.PI * 2;
      var rgb = hex ? _colorConvert.default.hex.rgb(hex).join(",") : "0,0,255";
      rgb = color ? _colorConvert.default.keyword.rgb(color) : rgb;
      canvas.style.zIndex = 10000;
      canvas.style.position = "fixed";
      var vw = canvas.width = window.innerWidth;
      var vh = canvas.height = window.innerHeight;
      body.appendChild(canvas); // Event coords

      var x = event.clientX;
      var y = event.clientY; // Delta - difference between event and farthest corner

      var dx = x < vw / 2 ? vw - x : x;
      var dy = y < vh / 2 ? vh - y : y;
      var radius = Math.sqrt(dx * dx + dy * dy);
      var ripple = {
        alpha: 0,
        radius: 0,
        x: x,
        y: y
      };
      var seconds = length;
      new _gsap.TimelineMax({
        onUpdate: drawRipple,
        onComplete: function onComplete() {
          return removeCanvas(seconds / 3);
        }
      }).to(ripple, seconds / 4, {
        alpha: 1
      }).to(ripple, seconds - seconds / 3, {
        radius: radius,
        ease: _gsap.Power1.easeIn
      }, 0).to(canvas, seconds / 3, {
        x: "100%",
        ease: _gsap.Power1.easeIn
      }, "+=.2");

      function drawRipple() {
        ctx.clearRect(0, 0, vw, vh);
        ctx.beginPath();
        ctx.arc(ripple.x, ripple.y, ripple.radius, 0, piTwo, false);
        var fillStyle = "rgba(".concat(rgb, ",").concat(ripple.alpha, ")");
        ctx.fillStyle = fillStyle;
        ctx.fill();
      }

      window.addEventListener("resize", onResize);

      function removeCanvas() {
        var wait = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        setTimeout(function () {
          body.removeChild(canvas);
        }, wait);
      }

      function onResize() {
        vw = canvas.width = window.innerWidth;
        vh = canvas.height = window.innerHeight;
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getDirection", function (from) {
      switch (from) {
        case "left":
          return {
            xPercent: -5
          };

        case "right":
          return {
            xPercent: 5
          };

        case "top":
          return {
            yPercent: -5
          };

        case "bottom":
          return {
            yPercent: 5
          };

        default:
          return {};
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "slideIn", function (_ref2, node, from) {
      var length = _ref2.length;
      new _gsap.TimelineMax().from(node, length, _objectSpread({}, _this.getDirection(from), {
        ease: _gsap.Power1.easeOut
      }));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onResize", function () {
      _this.vw = _this.canvas.width = window.innerWidth;
      _this.vh = _this.canvas.height = window.innerHeight;
    });

    _this.createRipple = _this.createRipple.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(PaintDrip, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.onResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_gatsbyPluginTransitionLink.default, {
        to: props.to,
        exit: {
          length: 0.6,
          trigger: function trigger(_ref3) {
            var exit = _ref3.exit,
                e = _ref3.e;
            return _this2.createRipple(exit, e, props.hex, props.color);
          }
        },
        entry: {
          delay: 0.4,
          length: 0.6,
          trigger: function trigger(_ref4) {
            var entry = _ref4.entry,
                node = _ref4.node;
            return _this2.slideIn(entry, node, "left");
          }
        }
      }, props.children));
    }
  }]);

  return PaintDrip;
}(_react.Component);

exports.default = PaintDrip;